<template>
  <div class="redact_container">
    <el-button class="top_btn" @click="addClick">变更</el-button>
    <ul class="info_box" v-loading="tableLoading">
      <li>车辆营运性质：{{configData.carServiceStr}}</li>
      <li>车辆厂牌：{{configData.carFactory}}</li>
      <li>车架号VIN：{{configData.vin}}</li>
      <li>发动机号码：{{configData.engineSn}}</li>
      <li>满载总质量：{{configData.fullyLaden}} <span class="unit" v-if="configData.fullyLaden">kg</span></li>
      <li style="justify-content: space-between;">长：{{configData.carSpecsLong}} <span class="unit" v-if="configData.carSpecsLong">mm</span> <span style="font-size:8px;"> X </span> 宽：{{configData.carSpecsWidth}} <span class="unit" v-if="configData.carSpecsWidth">mm</span> <span style="font-size:8px;"> X </span> 高：{{configData.carSpecsHigh}} <span class="unit" v-if="configData.carSpecsHigh">mm</span> </li>
      <li>整备质量：{{configData.curbWeight}} <span v-if="configData.curbWeight">kg</span></li>
      <li>准牵引总质量：{{configData.tractionMass}} <span class="unit" v-if="configData.tractionMass">kg</span></li>
      <li>核定载质量：{{configData.approvedLaden}} <span class="unit" v-if="configData.approvedLaden">kg</span></li>
      <li>核定座位数：{{configData.approvedPerson}}</li>
      <li>制造厂名：{{configData.createName}}</li>
      <li>出厂日期：{{configData.createTime}}</li>
      <li>国产/进口：{{configData.isDomesticStr}}</li>
      <li>底盘型号：{{configData.chassisModel}}</li>
      <li>发动机型号：{{configData.engineModel}}</li>
      <li>货厢内尺寸或容积：{{configData.containerSize}}</li>
      <li>发动机排量：{{configData.engineDisplacement}} <span class="unit" v-if="configData.enginePower">L</span></li>
      <li>发动机净功率：{{configData.enginePower }} <span class="unit" v-if="configData.emissionStandardStr">kw</span></li>
      <li>排放标准：{{configData.emissionStandardStr}}</li>
      <li>电池类型：{{configData.batteryType}}</li>
      <li>驱动电机型号：{{configData.motorModel}}</li>
      <li>电机功率：{{configData.motorPower}}</li>
      <li>动力类型：{{configData.powerTypeStr}}</li>
      <li>轴距（轮距）：{{configData.vehWheelbase}} <span class="unit" v-if="configData.vehWheelbase">mm</span></li>
      <li>车轴数：{{configData.axlesNum}}</li>
      <li>驱动：{{configData.vehDrive}}</li>
      <li>轮胎数：{{configData.tyreNum}}</li>
      <li>轮胎规格：{{configData.tyreType}}</li>
      <li>行车制动方式：{{configData.serviceBrakeStr}}</li>
      <li>ABS：{{configData.isAbsStr}}</li>
      <li>制动器形式（前轮）：{{configData.brakeTypeStr1}}</li>
      <li>制动器形式（后轮）：{{configData.brakeTypeStr2}}</li>
      <li>变速器形式：{{configData.transmissionTypeStr}}</li>
      <li>缓速器：{{configData.isRetarderStr}}</li>
      <li>空调系统：{{configData.isAirConditionerStr}}</li>
      <li>卫星定位装置：{{configData.isLocationStr}}</li>
      <li>备注：{{configData.remark}}</li>
    </ul>

    <v-changCarConfig :dialogShow.sync="changCarConfigShow" :dialogData="configData"></v-changCarConfig>
  </div>
</template>

<script>
import changCarConfig from './tabDialog/changCarConfig.vue';
export default {
  name: "",
  data() {
    return {
      changCarConfigShow: false,
      changCarConfigData:{},
      configData:{},
      tableLoading:false
    };
  },
  components: {
    "v-changCarConfig":changCarConfig
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableLoading = true;
      this.$http.getCarParamInfo({ id: this.netId }).then((res) => {
        this.tableLoading = false;
        if(res.code === 0){
          this.configData = res.data;
        }else{
          this.configData = {};
          this.$message.info(res.msg)
        }
      });
    },
    addClick() {
      this.changCarConfigShow = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "./redact.less";
.info_box {
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  li {
    width: 345px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #434343;
    display: flex;
    line-height: 40px;
    // justify-content: space-between;

    .li_title {
      text-align: right;
      font-size: 16px;
    }

    .li_text {
      font-size: 14px;
    }
    .unit{
      margin-left: 16px;
    }
  }
  .li_3 {
    justify-content: flex-start;
    > div {
      display: flex;
      margin-right: 15px;
    }
    .chenghao {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/redact_carConfig.vue